/** Kiosk list, rename, revoke and check-in key rotation (`devices:*`). Pairing is app-kiosk; the token it returns is shown there. */
import type { ApiClient } from "./client";

export interface Kiosk {
  id: string; branchId: string; label: string; mode: "scanner" | "wall"; status: "active" | "revoked";
  pairedByStaffId: string; lastSeenAt: number | null; createdAt: number; revokedAt: number | null;
}
export interface RotatedKey { kid: string; notBefore: number; notAfter: number }

export const listKiosks = (c: ApiClient) => c.get<{ kiosks: Kiosk[] }>("/kiosks").then((r) => r.kiosks);
export const renameKiosk = (c: ApiClient, id: string, label: string) => c.patch<{ kiosk: Kiosk }>(`/kiosks/${id}`, { label }).then((r) => r.kiosk);
export const revokeKiosk = (c: ApiClient, id: string) => c.del<{ kiosk: Kiosk; rotatedTo: string | null }>(`/kiosks/${id}`);
export const rotateCheckinKey = (c: ApiClient) => c.post<RotatedKey>("/checkin/keys/rotate", {});
